import DeleteAiCostLimit from '@Application/AiCostLimits/Limits/Commands/DeleteAiCostLimit';
import deleteAiCostLimit from '@Application/AiCostLimits/Limits/deleteAiCostLimit';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import aiCostLimitToDeleteSignal, {
	setAiCostLimitToDelete,
} from '@UI/Pages/Administration/AiCostLimits/Signals/aiCostLimitToDeleteSignal';
import useStrictAuthenticatedUser from '@UI/Providers/AuthenticatedUserProvider/useStrictAuthenticatedUser';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { useDispatch } from '@verclam/synapse';
import { ConfirmDialog } from '@verclam/ui-kit';

/** Deleting a limit is reversible (it can be defined again), hence a plain confirmation. */
const DeleteAiCostLimitDialog: React.FC = () => {
	const dispatch = useDispatch();
	const { user } = useStrictAuthenticatedUser();
	const accountId = user.account?.id ?? null;
	const limitId = useSignalValue(aiCostLimitToDeleteSignal);

	const handleHide = React.useCallback(() => {
		setAiCostLimitToDelete(null);
	}, []);

	const handleConfirm = React.useCallback(() => {
		if (accountId === null || limitId === null) {
			return;
		}

		dispatch(deleteAiCostLimit(new DeleteAiCostLimit(accountId, limitId))).catch(ignoreHandledError);
	}, [accountId, limitId, dispatch]);

	return (
		<ConfirmDialog
			blockScroll
			closable
			draggable={false}
			visible={limitId !== null}
			onHide={handleHide}
			header="Supprimer le plafond"
			message="La consommation de ce périmètre ne sera plus limitée. Les traitements bloqués pourront de nouveau être lancés ou relancés."
			acceptLabel="Supprimer"
			rejectLabel="Annuler"
			acceptSeverity="danger"
			accept={handleConfirm}
		/>
	);
};

export default DeleteAiCostLimitDialog;
